import { AutomationsPresentationV1Edge } from 'Automations/automationEditor'
import { parseNodeHandleId } from 'Automations/nodeDefinitions/helpers/nodeHandleId'

export const sortEdgesByHandleMapping = ({
  unsortedNodeEdges,
  handleMapping
}: {
  unsortedNodeEdges: AutomationsPresentationV1Edge[]
  handleMapping: Record<string, number> | undefined
}): AutomationsPresentationV1Edge[] => {
  if (!handleMapping) return unsortedNodeEdges

  return [...unsortedNodeEdges].sort((a, b) => {
    if (!a.sourceHandle || !b.sourceHandle) {
      throw new Error('Edge missing sourceHandle')
    }

    const handleIdA = parseNodeHandleId(a.sourceHandle).handleMapping
    const handleIdB = parseNodeHandleId(b.sourceHandle).handleMapping

    const orderA = handleIdA ? handleMapping[handleIdA] : undefined
    const orderB = handleIdB ? handleMapping[handleIdB] : undefined

    if (typeof orderA === 'undefined') {
      throw new Error(
        `Source handle "${a.sourceHandle}" not found in handleMapping`
      )
    }

    if (typeof orderB === 'undefined') {
      throw new Error(
        `Source handle "${b.sourceHandle}" not found in handleMapping`
      )
    }

    return orderA - orderB
  })
}
